export default Object.freeze({
  ProductManagement: "ProductManagement",
  Authentication: "Authentication",
});
